import React from 'react';
import { createRoot } from 'react-dom/client';
import Projects from './organism/projects';
import Layout from './organism/layout';
import Home from './organism/home';
import { BrowserRouter, Route, Routes } from '../node_modules/react-router-dom/dist/index';
window.addEventListener('load', function (event) {
    const container = this.document.createElement('div');
    const root = createRoot(container);
    root.render(React.createElement(BrowserRouter, null,
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/portfolio/", element: React.createElement(Layout, null) },
                React.createElement(Route, { index: true, element: React.createElement(Home, null) }),
                React.createElement(Route, { path: "projects", element: React.createElement(Projects, null) })))));
    this.document.body.appendChild(container);
});
